import React, {useEffect, useRef, useState} from 'react';

import {Button} from "../global/Button";
import {Line} from "../global/Line";

import introImg from "../../images/ambassador-figure.svg";
import Typed from "typed.js";

export const Intro = (props) => {
  const data = props.data || {};

  const labelRef = useRef(null);

  const [line, setLine] = useState(null);
  const textBlock = useRef(null);

  const typedOptions = {
    showCursor:false,
    typeSpeed: 30,
  };
  let typed = [
    {
      text : data.titlePart1,
      suptext : useRef(null),
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart2,
      suptext : useRef(null),
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart3,
      suptext : useRef(null),
      ref : useRef(null),
      typed : useRef(null)
    }
  ];
  const LineX = () =>{
    return <Line start={typed[2].ref} end={labelRef} color={"#08FFD0"}  />;
  };
  //Typed
  useEffect(() => {
    let nextWordDelay = 0;
    typed.forEach( (item, index) => {
      if(index !== 0){
        nextWordDelay += typed[index - 1].text.length * typedOptions.typeSpeed;
      }

      item.typed.current = new Typed(item.ref.current, {
        ...typedOptions,
        startDelay : nextWordDelay,
        strings: [
          item.text
        ],
        preStringTyped: (arrayPos, self) => {
          self.el.classList.remove('opacity-0')
          if (item.suptext?.current){
            item.suptext.current.classList.remove('opacity-0')
          }
        },
        onComplete: (self) => {
          if(index === typed.length - 1){
            setLine(<LineX />);

            textBlock.current.classList.remove('opacity-0')
            document.querySelector('.zg-ambassador-intro-img')?.classList.remove('opacity-0')
          }
        },
      });
    })
    return () => {
      // Make sure to destroy Typed instance during cleanup
      // to prevent memory leaks
      typed.forEach( (item, index) => {
        item.typed.current.destroy();
      });
    }
  }, []);

  return (
    <section className="pb-md-11 pb-lg-16 pt-14-rem pb-11 overflow-hidden">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-10 col-lg-12 col-xl-10 position-relative mb-6 mb-lg-5">
            <h1 className="mb-0 d-inline-flex flex-wrap align-items-start h2 position-relative">
              <span className="zg-text-bg opacity-0 bg-purple mb-1 mb-md-2 me-2" ref={typed[0].ref}></span>
              <span className="zg-label bg-purple me-1 opacity-0" ref={typed[0].suptext}>{data.suptext1}</span>
              <span className="zg-text-bg opacity-0 bg-white mb-1 me-2 mb-md-2" ref={typed[1].ref}></span>
              <span className="zg-text-bg opacity-0 bg-cyan me-2 mb-1 mb-md-2" ref={typed[2].ref}></span>
            </h1>
            <img src={introImg} className="position-absolute zg-ambassador-intro-img opacity-0 transition-opacity" alt="Ambassador" width="408" height="392" loading="lazy"/>
          </div>
        </div>
        <div className="row align-items-lg-start align-items-md-center opacity-0 transition-opacity" ref={textBlock}>
          <div
            className="col-12 col-md-6 col-lg-6 offset-lg-1 mb-11 mb-md-4 mb-lg-7 position-relative" style={{zIndex:1}}>
            {data.link && data.link.url && (
              <Button
                title={data.link.title}
                url={data.link.url}
                classes="btn-lg"
                external={data.link.target === '_blank'}
              />
            )}
          </div>
          <div className="col-10 offset-2 col-md-6 offset-md-6 col-lg-4 offset-lg-6 position-relative">
            <span ref={labelRef}
                  className="zg-label bg-cyan position-absolute end-100 top-0 me-lg-2">{data.number}</span>
            {data.text && (
              <p className="zg-text-lg mb-0">{data.text}</p>
            )}
          </div>
        </div>
        {line}
      </div>
    </section>
  )
}
